import { Button, Spinner } from "react-bootstrap";
import { clsx } from "clsx";
import styles from "../llm-summary.module.scss";
import { Icon } from "../../../../../../../components";
import Typography from "../../../../../../../components/typography/Typography";
import { Tooltip } from "../../../../../../../components/tooltip";

interface ILLMSummarySidebarButton {
  onClick: () => void;
  isHidden: boolean;
  isLoading?: boolean;
  showGenerateLabel?: boolean;
  isDisabled?: boolean;
}

const LLMSummarySidebarButton = ({
  onClick,
  isHidden,
  isLoading,
  showGenerateLabel,
  isDisabled
}: ILLMSummarySidebarButton) => (
  <div className={clsx(styles.llm_sidebar, isHidden && styles.hidden)}>
    <Tooltip
      content={
        <span>
          <b>AI Summary is currently unavailable.</b>
          <div>
            This feature has not been enabled for your organization. Please
            contact your administrator to activate AI Summary in the
            Configuration settings.
          </div>
        </span>
      }
      variant="basic"
      placement={"left"}
      disabled={!isDisabled}
    >
      <Button
        className={clsx(
          styles.llm_summary_sidebar_button,
          isDisabled && styles.disabled
        )}
        onClick={isDisabled ? undefined : onClick}
      >
        <Typography
          variant={"h5"}
          className={clsx(styles.llm_summary_sidebar_button_text, "text-white")}
        >
          <Icon name={"ai-indicator"} className={"mb-10"} />{" "}
          {showGenerateLabel ? "Generate " : ""}AI Summary
          {isLoading && (
            <span className={"pt-10"}>
              <Spinner
                animation="border"
                size="sm"
                variant="light"
                className={"ps-10"}
              />
            </span>
          )}
        </Typography>
      </Button>
    </Tooltip>
  </div>
);

export default LLMSummarySidebarButton;
